import {ChangeDetectorRef, Component, forwardRef, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {SelectOption} from './SelectOption';

@Component({
    selector: 'mm-select',
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectComponent implements OnChanges, ControlValueAccessor {
    public disabled: boolean = false;
    public internalValue: string = '';

    @Input()
    public style: 'dark' | 'light' = 'light';

    @Input()
    public options: SelectOption[] = [];

    public onTouched!: () => void;
    public onChange!: (value: string) => void;

    constructor(private cdr: ChangeDetectorRef) {}

    public ngOnChanges(changes: SimpleChanges): void {
        // If options change and we have a pending value, try to set it
        if ('options' in changes && this.internalValue.length > 0 && this.options.length > 0) {
            this.validateAndSetValue(this.internalValue);
            this.cdr.detectChanges();
        }
    }

    public writeValue(value: string): void {
        this.internalValue = value ?? '';
        this.validateAndSetValue(this.internalValue);
        this.cdr.detectChanges();
    }

    public registerOnChange(fn: (value: string) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cdr.detectChanges();
    }

    public onSelectChange(event: Event): void {
        const selectElement = event.target as HTMLSelectElement;
        const value = selectElement.value;
        this.internalValue = value;
        this.onChange(value);
        this.onTouched();
    }

    private validateAndSetValue(value: string): void {
        // Only set the value if it exists in options or options are empty
        if (this.options.length === 0 || this.options.some(opt => opt.value === value)) {
            this.internalValue = value;
        }
    }

}
